<template>
  <div id="main-content" class="edit-sub-driver">
    <el-col :offset="1" :span="22">
      <PageTitle :title="title" :backLink="backLink"></PageTitle>
      <form v-if="templateData">
        <el-row>
          <el-col :span="4"><span class="required-star">* </span><span class="form-lable">{{ $t('common.title') }}</span></el-col>
          <el-col :span="8">
            <el-input v-model="templateData.title"></el-input>
          </el-col>
          <el-col v-if="error_message.title" :span="8">
            <span v-for="(value, key) in error_message.title" :key="key" class="form-error"> {{ value }}</span>
          </el-col>
        </el-row>
        <el-row style="padding-top: 30px;">
          <el-col :span="4"><span class="form-lable">{{ $t('common.header') }}</span></el-col>
          <el-col :span="8">
            <el-input type="textarea" v-model="templateData.header" :rows="3"></el-input>
          </el-col>
        </el-row>
        <el-row style="padding-top: 30px;">
          <el-col :span="4"><span class="form-lable">{{ $t('common.footer') }}</span></el-col>
          <el-col :span="8">
            <el-input type="textarea" v-model="templateData.footer" :rows="3"></el-input>
          </el-col>
        </el-row>
        <el-row style="padding-top: 30px;">
          <el-col :span="4"><span class="form-lable">{{ $t('notification.reason_list') }}</span></el-col>
          <el-col :span="16" class="reason-add-section">
            <div class="reason-add-section__header clearfix">
              <el-button @click="addReason()" type="success" icon="el-icon-plus" circle></el-button>
              <span>{{ $t('notification.add_reason') }}</span>
            </div>
            <el-row v-for="(reason, index) in templateData.reason_list" :key="index">
              <el-col :span="2">{{ $t('common.title') }}</el-col>
              <el-col :span="6">
                <input class="input" v-model="reason.title" type="text" />
              </el-col>
              <el-col :span="2" :offset="2">{{ $t('common.type') }}</el-col>
              <el-col :span="6">
                <el-select v-model="reason.type">
                  <el-option
                          :key="NOTIFICATION_TEMPLATE_REASON_STRING"
                          :label="$t('common.text')"
                          :value="NOTIFICATION_TEMPLATE_REASON_STRING">
                  </el-option>
                  <el-option
                          :key="NOTIFICATION_TEMPLATE_REASON_DATE"
                          :label="$t('common.date')"
                          :value="NOTIFICATION_TEMPLATE_REASON_DATE">
                  </el-option>
                  <el-option
                          :key="NOTIFICATION_TEMPLATE_REASON_TEXT_BOX"
                          :label="$t('common.text_box')"
                          :value="NOTIFICATION_TEMPLATE_REASON_TEXT_BOX"
                  ></el-option>
                </el-select>
              </el-col>
              <el-col :span="2">
                <el-button @click="removeReason(index)" type="danger" icon="el-icon-minus" circle></el-button>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row style="padding-top: 50px">
          <el-button style="font-size: 20px; width: 30%" type="success" @click="submitAction">{{ $t('common.submit') }}</el-button>
        </el-row>
      </form>
    </el-col>
  </div>
</template>

<script>
  import PageTitle from '../../components/PageTitle.vue'
  import {
    NOTIFICATION_TEMPLATE_REASON_STRING,
    NOTIFICATION_TEMPLATE_REASON_DATE,
    NOTIFICATION_TEMPLATE_REASON_TEXT_BOX
  } from '@/config'

  export default {
    name: "EditPlace",
    components: {
      PageTitle
    },
    data: function () {
      return {
        backLink: `/parent-notification-template/detail?tid=${this.$route.query.tid}`,
        title: this.$t('notification.edit_parent_notification_template'),
        NOTIFICATION_TEMPLATE_REASON_STRING,
        NOTIFICATION_TEMPLATE_REASON_DATE,
        NOTIFICATION_TEMPLATE_REASON_TEXT_BOX,
        templateData: null,
        error_message: {
          title: []
        }
      }
    },
    mounted: function () {
      let successCallback = (response) => {
        this.templateData = Object.assign({}, response.data.data.parent_notification_template_info)
      }
      let payload = {
        successCallback,
        parent_notification_template_id: this.$route.query.tid
      }
      this.$store.dispatch('parentnotificationtemplate/getParentNotificationTemplateInfo', payload)
    },

    methods: {
      submitAction: function () {
        let check = this.validate()
        if (check) {
          let successCallback = () => {
            this.$router.push({path: '/parent-notification-template/detail', query: {tid: this.$route.query.tid}});
          }
          let payload = {
            successCallback,
            data: this.templateData,
            parent_notification_template_id: this.$route.query.tid
          }
          this.$store.dispatch('parentnotificationtemplate/editParentNotificationTemplate', payload);
        }
      },
      validate: function () {
        let check = true

        if (this.templateData.title === "") {
          check = false
          this.error_message.title.push('* ' + this.$t('common.title_is_required'))

          this.$store.commit('openNotification', {
            type: 'error',
            message: this.$t('common.please_check_input_error')
          })
        }

        return check
      },
      addReason: function () {
        this.templateData.reason_list.push({
          title: '',
          type: NOTIFICATION_TEMPLATE_REASON_STRING
        })
      },
      removeReason (index) {
        this.templateData.reason_list.splice(index, 1)
      }
    }
  }
</script>

<style scoped>

</style>
